import ImageTextCard from "@components/BasicComponents/Cards/ImageTextCard/ImageTextCard"
import ContainerWrapper from "@components/BasicComponents/Wrappers/ContainerWrapper/ContainerWrapper"
import Separator from "@components/CustomTypography/Separator/Separator"
import {AdvancedSideAssetMainContent} from "@hooks/WorkWithJson/GetComponentDataByKey/GetComponentDataByKeyTypes"
import React from "react"

import styles from "./AdvisorsSection.module.scss"

type Props = {
	data: AdvancedSideAssetMainContent[]
}

const AdvisorsSection = (props: Props) => {
	return (
		<section>
			<Separator size={128}>
				<ContainerWrapper>
					<div className={styles.cardContainer}>
						{props.data.map(
							(
								element: AdvancedSideAssetMainContent,
								index: number,
							) => {
								return (
									<ImageTextCard
										key={index}
										className={styles.cardBox}
										data={element}
										shortDesc={350}
										size={"M"}
										subtitleProps={{
											withoutHtml: true,
										}}
										titleProps={{
											withoutHtml: true,
										}}
									/>
								)
							},
						)}
					</div>
				</ContainerWrapper>
			</Separator>
		</section>
	)
}

export default AdvisorsSection
